import React from 'react';
import CategoryList from '../../../src/components/Category/CategoryList';
const items = [
    {
        title: 'Category #1',
    },
    {
        title: 'Category with long name #2',
    },
    {
        title: 'Category #3',
        iconKind: 'ExclamationMarkTriangle',
    },
];
const Example = () => (<div>
        <div className="dropdown-menu dropdown-menu--header position-relative show mr-7" aria-labelledby="headerMenu" data-placement="bottom-start">
            <CategoryList items={items}/>
        </div>
    </div>);
export default Example;
